export default __webpack_public_path__ + "static/media/no-cloud.c9180dc1.svg";